import React from "react";

import { Product } from "@core/types";
import { useHistory } from "react-router";
import { useIsViewFocused } from "../../../../hooks";
import { useGetIncludeProductsQuery, useGetNewestProductsQuery } from "../../../../providers/products";
import { useActiveOrMainShippingZone } from "../../../../providers/shippingZones";
import { useWishListData } from "../../../../providers/wishListStore";
import { useTranslation } from "react-i18next";
import Selection from "./Selection";
import { IonSkeletonText } from "@ionic/react";

const COLLECTION_PRODUCTS_COUNT = 3;

const IonSkeleton = () => (
  <div className="flex flex-col gap-2 h-[9.85rem]">
    <IonSkeletonText animated className="w-[8.25rem] h-[8.25rem] rounded-xl m-0" />
    <IonSkeletonText animated className="flex-start w-28 h-5 rounded-lg m-0" />
  </div>
);

const Selections = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const isViewFocused = useIsViewFocused();
  const { activeShippingZone } = useActiveOrMainShippingZone();
  const enableNewestProducts = !!activeShippingZone.id;

  const { data: fethchedNewestProducts, isLoading: isNewestProductsLoading } = useGetNewestProductsQuery(
    {
      zoneId: activeShippingZone.id,
      pageSize: COLLECTION_PRODUCTS_COUNT.toString(),
    },
    { enabled: enableNewestProducts },
  );

  const { wishListProducts: wishListProductsIds } = useWishListData();

  const newestProducts = fethchedNewestProducts?.products as Product[];

  const wishlistProductsEnabled = !!wishListProductsIds.length && isViewFocused;

  const { data: wishlistProducts, isLoading: isWishListLoading } = useGetIncludeProductsQuery({
    include: wishListProductsIds.slice(0, COLLECTION_PRODUCTS_COUNT),
    params: {
      zoneId: activeShippingZone.id,
      per_page: COLLECTION_PRODUCTS_COUNT.toString(),
    },
    options: {
      enabled: wishlistProductsEnabled,
    },
  });

  const handleGoToWishlist = () => {
    history.push("/wish-list");
  };

  const handleGoToNewestProducts = () => {
    history.push(`/product-shelf/34`);
  };

  const isNewestProductsEnabledAndLoading = enableNewestProducts && isNewestProductsLoading;
  const isWishlistProductsEnabledAndLoading = wishlistProductsEnabled && isWishListLoading;

  if (
    !isNewestProductsEnabledAndLoading &&
    !newestProducts?.length &&
    !wishlistProductsEnabled &&
    !isWishlistProductsEnabledAndLoading
  ) {
    return null;
  }

  return (
    <div className="flex flex-col gap-2.5">
      <div>{t("Collections")}</div>
      <div className="flex gap-4">
        {isNewestProductsEnabledAndLoading ? (
          <IonSkeleton />
        ) : (
          !!newestProducts?.length && (
            <Selection mySelectionData={newestProducts} onMySelectClick={handleGoToNewestProducts} title={t("NEW")} />
          )
        )}

        {isWishlistProductsEnabledAndLoading ? (
          <IonSkeleton />
        ) : (
          wishlistProductsEnabled &&
          !!wishlistProducts?.length && (
            <Selection mySelectionData={wishlistProducts} onMySelectClick={handleGoToWishlist} title={t("Wishlist")} />
          )
        )}
      </div>
    </div>
  );
};

export default Selections;
